// extracted by mini-css-extract-plugin
export var balloon = "balloon-module--balloon--3e83b";
export var balloonimg = "balloon-module--balloonimg--d2cfd";
export var balloonimgwrapper = "balloon-module--balloonimgwrapper--a8445";
export var balloonwrapper = "balloon-module--balloonwrapper--728b8";